import { NsStandout } from '@britishgasenergy/react-nucleus';

import { useTariffType } from 'components/direct-sales/quote/hooks/useTariffType';
import { useTariffStandoutFeatures } from 'components/direct-sales/quote/hooks/useTariffFeatures';
import { usePaymentMethod } from 'hooks/usePaymentMethod';

type Props = {
  product?: object;
};

export const testId = 'tariffStandoutTestId';

export const TariffStandout = ({ product }: Props) => {
  const { isPrePay } = usePaymentMethod();
  const { isVariable, isTracker } = useTariffType(product);
  const tariffStandoutFeatures = useTariffStandoutFeatures(product);

  if (isVariable && !isPrePay) {
    return (
      <NsStandout decoration="yellow" data-testid={testId}>
        <h5>Get peace of mind</h5>
        <p>
          With a fixed tariff you can relax, knowing your unit rates won&apos;t
          change.
        </p>
        <p>
          If we offer a cheaper fixed tariff you can choose to switch to it for
          free and there&apos;s no early exit fee if you move home.
        </p>
      </NsStandout>
    );
  }

  if (isTracker) {
    return (
      <NsStandout decoration="cyan" data-testid={testId}>
        <h5>About this tracker tariff</h5>
        {tariffStandoutFeatures[0]?.description}
      </NsStandout>
    );
  }

  return null;
};
